import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [business, setBusiness] = useState(undefined); // undefined = unknown

  const loadBusiness = useCallback(async () => {
    try {
      const { data } = await api.get("/business");
      setBusiness(data || null);
      return data || null;
    } catch {
      setBusiness(null);
      return null;
    }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("da_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadBusiness();
    } catch {
      localStorage.removeItem("da_token");
      setUser(false);
    }
  }, [loadBusiness]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const setSession = async (data) => {
    localStorage.setItem("da_token", data.access_token);
    setUser(data.user);
    await loadBusiness();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed", e); }
    localStorage.removeItem("da_token");
    setUser(false);
    setBusiness(undefined);
  };

  return (
    <AuthContext.Provider value={{ user, business, setBusiness, loadBusiness, setSession, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
